import React, { useState, useEffect } from 'react';
import AdminLogin from './admin/AdminLogin';
import AdminProductsPage from './admin/AdminProductsPage';
import AdminCommentsPage from './admin/AdminCommentsPage';
import AdminQuotesPage from './admin/AdminQuotesPage';
import QuoteGeneratorPage from './admin/QuoteGeneratorPage';
import AdminQuotesNewPage from './admin/AdminQuotesNewPage';
import AdminInvoicesPage from './admin/AdminInvoicesPage';
import AdminStatsPage from './admin/AdminStatsPage';
import AdminSettingsPage from './admin/AdminSettingsPage';
import AdminEmailSettingsPage from './admin/AdminEmailSettingsPage';
import { adminCommentsAPI } from '../services/api';

export const AdminPage = () => {
  const [logged, setLogged] = useState(() => {
    if (typeof window === 'undefined') return false;
    return !!localStorage.getItem('adminAuth');
  });
  const [tab, setTab] = useState('products');
  const [pendingCount, setPendingCount] = useState(0);
  const [loadingCount, setLoadingCount] = useState(false);

  const loadPending = async () => {
    try {
      setLoadingCount(true);
      const items = await adminCommentsAPI.list();
      const count = (Array.isArray(items) ? items : []).filter(c => !c.approved).length;
      setPendingCount(count);
    } catch (e) {}
    finally { setLoadingCount(false); }
  };

  useEffect(() => { if (logged) loadPending(); }, [logged, tab]);
  useEffect(() => { const h=()=>loadPending(); window.addEventListener('comments-changed', h); return ()=>window.removeEventListener('comments-changed', h); }, []);

  if (!logged) {
    return (
      <section className="py-10 bg-gray-50 min-h-screen">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <AdminLogin onSuccess={() => setLogged(true)} />
        </div>
      </section>
    );
  }

  return (
    <section className="py-10 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {pendingCount > 0 && (
          <div className="mb-4 p-3 rounded-lg border bg-yellow-50 text-yellow-800 flex items-center justify-between">
            <div>{pendingCount} commentaire{pendingCount>1?'s':''} en attente d'approbation</div>
            <div className="flex items-center gap-2">
              <button onClick={() => setTab('comments')} className="px-3 py-1 bg-yellow-600 text-black rounded">Ouvrir</button>
              <button onClick={loadPending} className="px-3 py-1 bg-white border rounded">{loadingCount ? '...' : 'Recharger'}</button>
            </div>
          </div>
        )}
        <script dangerouslySetInnerHTML={{__html: `window.dispatchEvent(new CustomEvent('comments-pending-count', { detail: ${pendingCount} }));`}} />

        <div className="flex items-center gap-3 mb-6 flex-wrap">
          <button onClick={() => setTab('products')} className={`px-4 py-2 rounded ${tab==='products' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Produits</button>
          <button onClick={() => setTab('quotes')} className={`px-4 py-2 rounded ${tab==='quotes' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Devis Reçus</button>
          <button onClick={() => setTab('quotesnew')} className={`px-4 py-2 rounded ${tab==='quotesnew' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Gérer Devis</button>
          <button onClick={() => setTab('invoices')} className={`px-4 py-2 rounded ${tab==='invoices' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Factures</button>
          <button onClick={() => setTab('stats')} className={`px-4 py-2 rounded ${tab==='stats' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>📊 Statistiques</button>
          <button onClick={() => setTab('comments')} className={`px-4 py-2 rounded ${tab==='comments' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Commentaires{pendingCount>0?` (${pendingCount})`:''}</button>
          <button onClick={() => setTab('email')} className={`px-4 py-2 rounded ${tab==='email' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Email</button>
          <button onClick={() => setTab('settings')} className={`px-4 py-2 rounded ${tab==='settings' ? 'bg-yellow-600 text-black' : 'bg-white border'}`}>Paramètres</button>
          <button onClick={loadPending} className="ml-auto px-3 py-2 bg-gray-200 border rounded">Recharger</button>
        </div>
        {tab === 'products' && <AdminProductsPage />}
        {tab === 'quotes' && <AdminQuotesPage />}
        {tab === 'quotesnew' && <AdminQuotesNewPage />}
        {tab === 'generator' && <QuoteGeneratorPage />}
        {tab === 'invoices' && <AdminInvoicesPage />}
        {tab === 'stats' && <AdminStatsPage />}
        {tab === 'comments' && <AdminCommentsPage />}
        {tab === 'email' && <AdminEmailSettingsPage />}
        {tab === 'settings' && <AdminSettingsPage />}
      </div>
    </section>
  );
};